import Environment from '../../Environment';
import stages from '../stages';
import MockSplit from '../../MockSplit';
import Region from '../../../constants/region';

const prod = new Environment({
    name: stages.PRODUCTION,
    regions: [Region.CDI],
});

const demo = new Environment({
    name: stages.DEMO,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const staging = new Environment({
    name: stages.STAGING,
    regions: [Region.CDI],
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    regions: [Region.CDI],
});

const enable_autopilot_cost_modality = new MockSplit({
    name: 'enable_autopilot_cost_modality',
    environments: [local, dev, staging, demo, prod],
});

export default enable_autopilot_cost_modality;
